import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
  },

  mutations: {
    SOCKET_ONOPEN(state, event) {
      Vue.prototype.$socket = event.currentTarget;
      state.socket.isConnected = true;
      console.log('Connexion socket réussie.');
    },
    SOCKET_ONCLOSE(state) {
      state.socket.isConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.error(event);
    },
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message;
    },
    SOCKET_RECONNECT(state, count) {
      console.info('Socket reconnexion...', count);
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
  },

  getters: {
    getSocketMessage: state => state.socket.message,
  },

  actions: {
    cacheFile(context, e) {
      if (this.state.socket.isConnected) {
        console.log(e);
        Vue.prototype.$socket.sendObj({
          action: 'SAVE_FILE',
          args: {
            url: e.fileUrl,
            name: e.fileName,
          },
        });
      } else {
        console.log('Enregistrement local impossible: écran virtuel');
      }
    },
  },
});
